import ScrollView from './scrollIntoViewport';

const scrollToID = (id, verticalALign) => ScrollView("progress", id, verticalALign)


export default scrollToID;

export const horizontalScrollToID = (fatherID, sonID, verticalAlign = 'center', horizontalAlign = "center") => ScrollView(fatherID, sonID, verticalAlign, horizontalAlign)

